/**
 * Csv Schema of AuditoriaMotivo
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {AuditoriaMotivo} from '@/model/resource/AuditoriaMotivo'

/* TODO: review generated schema */
export class CsvAuditoriaMotivoSchema extends Schema {
  readonly name = 'CsvAuditoriaMotivo'

  readonly fieldSet: FieldSet<AuditoriaMotivo> = {
    idMotivoPk: schema => schema.model.idMotivoPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    nome: schema => schema.model.nome,
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
